import { render, staticRenderFns } from "./entityDialogDis.vue?vue&type=template&id=15ab513d&scoped=true&"
import script from "./entityDialogDis.vue?vue&type=script&lang=js&"
export * from "./entityDialogDis.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogDis.vue?vue&type=style&index=0&id=15ab513d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab513d",
  null
  
)

export default component.exports